export default __webpack_public_path__ + "static/feature1-688f90c3a29dec9282f1c3272c2ccbb3.mp4";